import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { elipsis } from 'utils';
import Link from 'components/Link';
import PubSub from 'services/PubSub/';
import ProductControls from 'components/ProductControls';
import ProductPrices from 'components/ProductPrices';
import ImageLoad from 'components/ImageLoad';
import ProductFlags from 'components/ProductFlags';
import notImage from 'images/foto_en_preparacion.png';
import TagManagerService from 'services/TagManager';
import TimerProduct from './TimerProduct';
import CMSFactory from 'factories/CMS';
import {translateFlag} from 'config/constants';
import style from './style.scss';//NOSONAR


const ShelfProduct = (props) => {
    let controlsConfig = null;
    const product = props.product;
    const item = product.items ? product.items[0] : false;
    let qtyInit = props.qtyInit ? (props.qtyInit * 1) : 0;
    let callback = props.callback;
    const notPDP = props.notPDP;
    
    const [load, setLoad] = useState(null);

    if (item) {
        controlsConfig = {
            unitSale: (product['Pesable x Unidad'] && product['Pesable x Unidad'][0]) ? translateFlag[product['Pesable x Unidad'][0]] : false,
            unitMultiplier: item.unitMultiplier,
            measurementUnit: item.measurementUnit,
            maxItems: item.maxItems - (item.inCart ? item.inCart : 0),
            customClass: props.small ? props.small : false,
            tagManagerData: { product: product, listTitle: props.listTitle, position: props.position }
        };

    }
    
    const getImage = (item, sizes) => {
        let imageUrl = item && item.images[0] ? item.images[0].imageUrl : null;
        
        if (!imageUrl) return null;
        
        const imageSufix = imageUrl.split('/').slice(-1);
        
        return imageUrl.replace('http://', 'https://').replace('/' + imageSufix, '-' + sizes + '-' + sizes) + '/' + imageSufix;
    }

    const hasStock = (item) => {
        if (!item) return false;
        const commertialOffer = (item.sellers && item.sellers[0]) ? item.sellers[0].commertialOffer : false;
        return commertialOffer && commertialOffer.ListPrice !== 0;
    }
        
    const openPreView = (product) => {
        PubSub.dispatch('open_product_preview', { product: product, title: props.listTitle, position: props.position });
    }
        
    const openModalAddToList = (itemID) => {
        PubSub.dispatch('add_to_list_open', { skuId: itemID, config: controlsConfig });
    }
        
    const producRedirect = () => {
        PubSub.dispatch('product_redirect');
    }
        
    const productClick = () => {
        TagManagerService.productClick(props.product, props.listTitle, props.position);
    }
    
    const callbackLoading = (loading) => {
        setLoad(loading);
    }

    
    const skuData = item && product.SkuData && product.SkuData[item.itemId] ? product.SkuData[item.itemId] : {};
    const productImage = item ? getImage(item, 150) : product.ImageUrl;
    const link = notPDP ? '#' : (product.linkText ? `/${product.linkText}/p` : '');
    const stock = item ? hasStock(item) : false;
    const limitTitle = props.limitTitle || 49;
    
    const dateServer = item && item.date_server ? item.date_server : new Date().getTime();
    const dateEnd = CMSFactory.milliseconds(item.end_date);
    const dateInit = CMSFactory.milliseconds(item.start_date);
    const productName = product.productName || product.ProductName;
    if (item) {
        item.skuData = item.skuData || {};
    }

    const extraActions = (
        <div className="shelf-product-extra-actions">
            {item && <button className="font-icn view-more tooltip-container mobile-click" onClick={() => openPreView(product)}>
                <span className="tooltip">Vista Rápida</span>
            </button>}
            <button className="font-icn add-to-list tooltip-container mobile-click" onClick={() => openModalAddToList(item.itemId || product.Id)}>
                <span className="tooltip">Agregar a una lista</span>
            </button>
        </div>
    );

    return (
        <div className="shelf-product-island">
            <div className="shelf-product-top-island" onClick={() => producRedirect()}>
                <div className="shelf-product-image-island">
                    {!load && extraActions}
                    <Link to={link} onClick={productClick} className="shelf-wrap-image" aria-label={productName}>
                        {productImage && <ImageLoad src={productImage} errorImage={notImage} alt={productName} />}
                    </Link>
                </div>
                <div className="container-shelf-info-product">
                    <div className="shelf-info-product">
                        {item && <ProductFlags item={item} nutritionalTag={true} />}
                        <Link to={link} onClick={productClick} title={productName} className="shelf-product-title"><h2>{elipsis(productName, limitTitle)}</h2></Link>
                        {(!!item.unitMultiplier) && <span className="shelf-single-unit">{item.unitMultiplier} {item.measurementUnit}</span>}
                        <h3 className="shelf-product-brand">{product.brand}</h3>
                    </div>
                    {!!qtyInit && <span className="shelf-product-init">Solicitado {qtyInit} un</span>}
                </div>
            </div>

            {stock && <ProductPrices item={item} skuData={skuData} onlyCurrentPrice={true} productDetail={false} />}
            {(item.time && stock) && <TimerProduct dateToday={dateServer} dateInit={dateInit} dateEnd={dateEnd} />}
            {stock && <div className='shelf-product-bottom-btns'>
                <ProductControls id={item.itemId} config={controlsConfig} quantity={item.quantity} inCart={item.inCart} qtyInit={qtyInit} callback={callback} callbackLoading={callbackLoading}/>
            </div>}
            {!stock && <div className="no-stock">
                <i className="font-icn alert"></i>
                <span className="no-stock-text">Sin Stock</span>
            </div>}
        </div>
    )
}

ShelfProduct.propTypes = {
    product: PropTypes.object,
    small: PropTypes.bool,
    listTitle: PropTypes.string,
    position: PropTypes.number,
    item: PropTypes.object,
    limitTitle: PropTypes.number,
    callback: PropTypes.func,
    qtyInit: PropTypes.string,
    notPDP: PropTypes.bool
};

export default ShelfProduct
